import {defaultFilters} from './state';

export function setPreloader(state, preloader) {
  state.preloader = preloader;
}

export function setBranchOffices(state, branch_offices) {
  state.branch_offices = branch_offices;
}

export function setLines(state, lines) {
  state.lines = lines;
}

export function setBrands(state, brands) {
  state.brands = brands;
}

export function setBranchOfficesWarehouses(state, branch_offices_warehouses) {
  state.branch_offices_warehouses = branch_offices_warehouses;
}

export function setConsolidatedKardex(state, consolidated_kardex) {
  state.consolidated_kardex = consolidated_kardex;
}

export function resetFilters(state) {
  state.filters = defaultFilters();
  state.consolidated_kardex = [];
}

export function setBranchOfficeFilter(state, branch_office_id) {
  state.filters.branch_office_id = branch_office_id;
}

export function setBranchOfficeWarehouseFilter(state, branch_office_warehouse_id) {
  state.filters.branch_office_warehouse_id = branch_office_warehouse_id;
}



// WEBPACK FOOTER //
// ./src/modules/consolidated_kardex/mutations.js